(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ryb-curly2sw-card"] && !Shopify.designMode) return;
  try {
    (() => {
  const bindCurlyZoom = (options, host) => {
    const displayId = options.dataset.curlyDisplayMediaId;
    const zoomId = options.dataset.curlyZoomMediaId;
    if (!displayId || !zoomId || displayId === zoomId) return;
    const gallery = host.querySelector('media-gallery');
    if (!gallery) return;
    const zoomFrames = [...gallery.querySelectorAll('.dialog-zoomed-gallery > li')];
    const displayIndex = zoomFrames.findIndex(frame => frame.id.startsWith('product-' + displayId + '-'));
    const zoomIndex = zoomFrames.findIndex(frame => frame.id.startsWith('product-' + zoomId + '-'));
    if (displayIndex < 0 || zoomIndex < 0) return;
    // Indeksy wynikają z rzeczywistego natywnego DOM, nie z dawnej kolejności.
    gallery.querySelectorAll('button, slideshow-slide').forEach(control => {
      const current = control.getAttribute('on:click');
      if (!current) return;
      const original = control.dataset.curlyOriginalZoomAction || current;
      const match = original.match(/^(.*\/(?:zoom|open)\/)(\d+)$/);
      if (!match || Number(match[2]) !== displayIndex) return;
      control.dataset.curlyOriginalZoomAction = original;
      control.setAttribute('on:click', match[1] + zoomIndex);
      const preload = control.getAttribute('on:pointerenter');
      if (preload && /^\/preloadImage\/\d+$/.test(preload)) control.setAttribute('on:pointerenter', '/preloadImage/' + zoomIndex);
    });
  };
  const init = () => {
    document.querySelectorAll('[data-ryb-curly2sw-list] [data-ryb-fa-family-menu]').forEach(menu => {
      if (menu.dataset.curlyMenuReady) return;
      menu.dataset.curlyMenuReady = 'true';
      const desktop = window.matchMedia('(min-width: 900px)');
      const sync = () => { menu.open = desktop.matches; };
      sync(); desktop.addEventListener('change', sync);
    });
    document.querySelectorAll('[data-ryb-curly2sw]').forEach(options => {
      const host = options.closest('.shopify-section');
      const page = host?.querySelector('.product-information');
      if (!host || !page) return;
      bindCurlyZoom(options, host);
      if (options.dataset.curlyHold === 'true' && !host._rybCurlyHold) {
        host._rybCurlyHold = true;
        host.querySelectorAll('product-form-component').forEach(component => {
          component.querySelectorAll('input[name="id"]').forEach(input => { input.disabled = true; });
          component.querySelectorAll('button[type="submit"]').forEach(button => { button.disabled = true; });
        });
        host.addEventListener('submit', event => {
          if (event.target.matches('form[action*="/cart/add"]')) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, true);
      }
      if (options.dataset.curlyReady) return;
      options.dataset.curlyReady = 'true';
      const gallery = page.querySelector('media-gallery .media-gallery__grid');
      const details = page.querySelector('.product-details');
      if (!gallery || !details) return;
      // Pierwszeństwo mają wybrane przez Katalog ujęcia tego samego koloru.
      // Liczba widocznych zdjęć zależy od naturalnych proporcji i wysokości treści.
      let queued = false;
      const update = () => {
        queued = false;
        const frames = [...gallery.children].filter(frame => frame.querySelector('img'));
        if (!frames.length) return;
        const width = gallery.getBoundingClientRect().width;
        if (!width) return;
        const gap = parseFloat(getComputedStyle(gallery).rowGap) || 8;
        const target = details.getBoundingClientRect().height;
        let best = Math.min(2, frames.length), distance = Infinity, total = 0;
        frames.forEach((frame, index) => {
          const img = frame.querySelector('img');
          const w = Number(img.getAttribute('width')) || img.naturalWidth;
          const h = Number(img.getAttribute('height')) || img.naturalHeight;
          const ratio = w > 0 && h > 0 ? w / h : 1.25;
          total += width / ratio + (index ? gap : 0);
          if (index + 1 >= Math.min(2, frames.length)) {
            const difference = Math.abs(total - target);
            if (difference < distance) { best = index + 1; distance = difference; }
          }
        });
        frames.forEach((frame, index) => { frame.dataset.curlyMainVisible = index < best ? 'true' : 'false'; });
      };
      const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
      const observer = new ResizeObserver(schedule);
      observer.observe(gallery); observer.observe(details);
      document.fonts?.ready.then(schedule);
      gallery.querySelectorAll('img').forEach(img => img.addEventListener('load', schedule));
      window.addEventListener('resize', schedule, { passive: true });
      schedule();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  window.addEventListener('load', init, { once: true });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:update', () => requestAnimationFrame(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ryb-megabass-standard-card"] && !Shopify.designMode) return;
  try {
    (() => {
 const init=()=>document.querySelectorAll('[data-ryb-megabass-whole-layout]').forEach(options=>{
  const host=options.closest('.shopify-section'),page=host?.querySelector('.product-information'),details=page?.querySelector('.product-details'),gallery=page?.querySelector('media-gallery .media-gallery__grid');
  if(!details||!gallery)return;
  const description=host.querySelector('[data-ryb-megabass-whole-description]'),guide=host.querySelector('[data-ryb-megabass-whole-guide]');
  if(description)details.append(description);if(guide){details.append(guide);guide.querySelectorAll('video').forEach(v=>{v.muted=true;v.defaultMuted=true;});}
  if(options.dataset.mbWholeReady)return;options.dataset.mbWholeReady='true';let queued=false;
  const update=()=>{queued=false;const frames=[...gallery.children].filter(f=>f.querySelector('img')),width=gallery.getBoundingClientRect().width;if(!frames.length||!width)return;const target=details.getBoundingClientRect().height,gap=parseFloat(getComputedStyle(gallery).rowGap)||8;let total=0,best=Math.min(2,frames.length),distance=Infinity;frames.forEach((f,i)=>{const img=f.querySelector('img'),w=Number(img.getAttribute('width'))||img.naturalWidth,h=Number(img.getAttribute('height'))||img.naturalHeight;total+=width*(w>0&&h>0?h/w:0.8)+(i?gap:0);if(i+1>=Math.min(2,frames.length)&&Math.abs(total-target)<distance){distance=Math.abs(total-target);best=i+1;}});frames.forEach((f,i)=>{f.dataset.mbMainVisible=i<best?'true':'false';});};
  const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(update);}};const observer=new ResizeObserver(schedule);observer.observe(gallery);observer.observe(details);document.fonts?.ready.then(schedule);gallery.querySelectorAll('img').forEach(img=>img.addEventListener('load',schedule));window.addEventListener('resize',schedule,{passive:true});schedule();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();window.addEventListener('load',init,{once:true});document.addEventListener('shopify:section:load',init);document.addEventListener('variant:update',()=>requestAnimationFrame(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ryb-megabass-standard-list"] && !Shopify.designMode) return;
  try {
    (() => { const init=()=>document.querySelectorAll('[data-mb-list-menu]').forEach(menu=>{if(menu.dataset.mbReady)return;menu.dataset.mbReady='true';menu.open=window.matchMedia('(min-width:900px)').matches;});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ryb-mj-megabass-20261021"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => document.querySelectorAll('[data-ryb-megabass-shared-layout]').forEach(options => {
    const host = options.closest('.shopify-section');
    const page = host?.querySelector('.product-information');
    const details = page?.querySelector('.product-details');
    const gallery = page?.querySelector('media-gallery .media-gallery__grid');
    if (!details || !gallery) return;
    const description = host.querySelector('[data-ryb-megabass-shared-description]');
    const guide = host.querySelector('[data-ryb-megabass-shared-guide]');
    if (description) details.append(description);
    if (guide) { details.append(guide); guide.querySelectorAll('video').forEach(video => { video.muted = true; video.defaultMuted = true; }); }
    if (options.dataset.mbSharedReady) return;
    options.dataset.mbSharedReady = 'true';
    let queued = false;
    const update = () => {
      queued = false;
      const frames = [...gallery.children].filter(frame => frame.querySelector('img'));
      const width = gallery.getBoundingClientRect().width;
      if (!frames.length || !width) return;
      const target = details.getBoundingClientRect().height;
      const gap = parseFloat(getComputedStyle(gallery).rowGap) || 8;
      let total = 0, best = Math.min(2,frames.length), distance = Infinity;
      frames.forEach((frame,index) => {
        const image = frame.querySelector('img');
        const w = Number(image.getAttribute('width')) || image.naturalWidth;
        const h = Number(image.getAttribute('height')) || image.naturalHeight;
        total += width * (w > 0 && h > 0 ? h/w : 0.8) + (index ? gap : 0);
        if (index+1 >= Math.min(2,frames.length) && Math.abs(total-target) < distance) { distance = Math.abs(total-target); best = index+1; }
      });
      frames.forEach((frame,index) => { frame.dataset.mbMainVisible = index < best ? 'true' : 'false'; });
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    const observer = new ResizeObserver(schedule); observer.observe(gallery); observer.observe(details);
    document.fonts?.ready.then(schedule);
    gallery.querySelectorAll('img').forEach(img => img.addEventListener('load',schedule));
    window.addEventListener('resize',schedule,{passive:true}); schedule();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  window.addEventListener('load',init,{once:true});
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('variant:update',() => requestAnimationFrame(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ryb-oneten-sr-standard-card"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    document.querySelectorAll('[data-ryb-oneten-sr-standard-list] [data-sr-model-menu]').forEach(menu => {
      if (menu.dataset.srMenuReady) return;
      menu.dataset.srMenuReady = 'true';
      const desktop = window.matchMedia('(min-width: 900px)');
      const sync = () => { menu.open = desktop.matches; };
      sync(); desktop.addEventListener('change', sync);
    });
    document.querySelectorAll('[data-ryb-oneten-sr-standard]').forEach(options => {
      const host = options.closest('.shopify-section');
      const page = host?.querySelector('.product-information');
      if (!host || !page) return;
      if (options.dataset.srHold === 'true' && !host._rybSRHold) {
        host._rybSRHold = true;
        host.querySelectorAll('product-form-component').forEach(component => {
          component.querySelectorAll('input[name="id"]').forEach(input => { input.disabled = true; });
          component.querySelectorAll('button[type="submit"]').forEach(button => { button.disabled = true; });
        });
        host.addEventListener('submit', event => {
          if (event.target.matches('form[action*="/cart/add"]')) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, true);
      }
      if (options.dataset.srReady) return;
      options.dataset.srReady = 'true';
      const gallery = page.querySelector('media-gallery .media-gallery__grid');
      const details = page.querySelector('.product-details');
      if (!gallery || !details) return;
      // Pierwszeństwo mają wybrane przez Katalog ujęcia tego samego koloru.
      // Liczba widocznych zdjęć zależy od naturalnych proporcji i wysokości treści.
      let queued = false;
      const update = () => {
        queued = false;
        const frames = [...gallery.children].filter(frame => frame.querySelector('img'));
        if (!frames.length) return;
        const width = gallery.getBoundingClientRect().width;
        if (!width) return;
        const gap = parseFloat(getComputedStyle(gallery).rowGap) || 8;
        const target = details.getBoundingClientRect().height;
        let best = Math.min(2, frames.length), distance = Infinity, total = 0;
        frames.forEach((frame, index) => {
          const img = frame.querySelector('img');
          const w = Number(img.getAttribute('width')) || img.naturalWidth;
          const h = Number(img.getAttribute('height')) || img.naturalHeight;
          const ratio = w > 0 && h > 0 ? w / h : 1.25;
          total += width / ratio + (index ? gap : 0);
          if (index + 1 >= Math.min(2, frames.length)) {
            const difference = Math.abs(total - target);
            if (difference < distance) { best = index + 1; distance = difference; }
          }
        });
        frames.forEach((frame, index) => { frame.dataset.srMainVisible = index < best ? 'true' : 'false'; });
      };
      const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
      const observer = new ResizeObserver(schedule);
      observer.observe(gallery); observer.observe(details);
      document.fonts?.ready.then(schedule);
      gallery.querySelectorAll('img').forEach(img => img.addEventListener('load', schedule));
      window.addEventListener('resize', schedule, { passive: true });
      schedule();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  window.addEventListener('load', init, { once: true });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:update', () => requestAnimationFrame(init));
})();
  } catch(e) { console.error(e); }
})();

})();
